import { objectToGetParams } from "@utils/link";
import { LinkedinService } from "./linkedinService";

// 'https://linkedin.com/shareArticle' +
// objectToGetParams({ url, mini: 'true', title, summary, source })

export class BrowserLinkedinService implements LinkedinService {
	async openShareDialog(url: string): Promise<void> {
		return new Promise(function () {
			window.open("https://linkedin.com/shareArticle" + objectToGetParams({ url, mini: "true" }));
			// window.open(
			// 	"http://www.linkedin.com/shareArticle?mini=true&url=" +
			// 		encodeURIComponent(url) +
			// 		"&text=" +
			// 		encodeURIComponent(text) +
			// 		`&auth=tooshare:@earlyaccesskey`,
			// 	"",
			// 	"left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
			// );
		});
	}
}
